import { CustomTypeEnum } from '@semanticedge/persistence-service-noheaders-client/src'
import type { ValidatorFunctionFactory } from '@repo/commons/models'
import { validateEmptyString, validateFloat, validateInteger } from '@repo/commons/utils'

const getLeverTypeValidators = (): Partial<Record<CustomTypeEnum, ValidatorFunctionFactory>> => ({
	[CustomTypeEnum.Float]: validateFloat,
	[CustomTypeEnum.Integer]: validateInteger
})

export const getLeverValueValidators = (
	leverType: CustomTypeEnum | undefined
): ValidatorFunctionFactory[] => {
	const typeValidator = leverType ? getLeverTypeValidators()[leverType] : undefined

	return typeValidator ? [validateEmptyString, typeValidator] : [validateEmptyString]
}
